/**
 * Auth 도메인 입력 제약.
 *
 * 백엔드 DTO(`RegisterDto`, `CreateAccountDto` 등) 의 class-validator 데코레이터
 * 값과 1:1 동기화해야 한다. 변경 시 양쪽 동시에.
 */

// ── 비밀번호 ─────────────────────────────────────────────────────
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 200;

// ── 이름 / 닉네임 ───────────────────────────────────────────────
export const NAME_MAX_LENGTH = 50;
export const NICKNAME_MIN_LENGTH = 2;
export const NICKNAME_MAX_LENGTH = 20;
/** 닉네임 자동 생성 시 끝에 붙는 4자리 숫자 범위 (1000~9999) */
export const NICKNAME_RANDOM_MIN = 1000;
export const NICKNAME_RANDOM_RANGE = 9000;

// ── 아이디 ─────────────────────────────────────────────────────
export const LOGIN_ID_MIN_LENGTH = 4;
export const LOGIN_ID_MAX_LENGTH = 20;

// ── 회사명 ─────────────────────────────────────────────────────
export const COMPANY_NAME_MAX_LENGTH = 50;

// ── 사업자등록번호 (하이픈 없는 숫자) ───────────────────────────
export const BUSINESS_NUMBER_LENGTH = 10;
export const BUSINESS_NUMBER_PREFIX_LENGTH = 3;
export const BUSINESS_NUMBER_MIDDLE_LENGTH = 2;
export const BUSINESS_NUMBER_MIDDLE_END = 5;

// ── 휴대폰 ─────────────────────────────────────────────────────
export const PHONE_NUMBER_LENGTH = 11;
/** OTP 발송 후 재요청까지 쿨다운 (초) */
export const PHONE_OTP_RESEND_COOLDOWN_SECONDS = 60;
/** OTP 만료 시간 (분) */
export const PHONE_OTP_TTL_MINUTES = 2;
/** OTP 코드 자리수 */
export const PHONE_OTP_CODE_LENGTH = 6;
